// @ts-nocheck
import { Items } from "@pdfking/tfunc"
import { ordered_object } from "./ordered_object"

/**
 * Merges multiple objects into one.
 *
 * Later objects override earlier ones for duplicate keys.
 *
 * @param args - Objects to merge
 * @returns Merged object
 *
 * @example
 * ```ts
 * import { merge } from "@pdfking/rfunc"
 *
 * merge({ a: 1 }, { b: 2 }) // { a: 1, b: 2 }
 * merge({ a: 1, b: 2 }, { b: 3 }) // { a: 1, b: 3 }
 * merge() // {}
 * ```
 */
export const merge = (...args) =>
  ordered_object(args.reduce((a, b) => a.concat(Items(b)), []))
